import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { ThemeService } from '../../services/theme.service';
import { UserPreferencesService } from '../../services/user-preferences.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';
import { MatLabel } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  imports: [UtilityToolbarComponent, MatLabel, MatRadioModule, FormsModule],
})
export class UserSettingsComponent implements OnInit, OnDestroy {
  private themeSvc = inject(ThemeService);
  private prefSrvc = inject(UserPreferencesService);

  currentTheme = 'RightBridge';
  currentScheme = 'light';

  unsubscribe: Subject<any> = new Subject();

  ngOnInit(): void {
    this.prefSrvc
      .getTheme()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: resp => {
          if (resp.theme) {
            this.currentTheme = resp.theme;
            this.themeSvc.setTheme(resp.theme);
          }
        },
      });

    this.prefSrvc
      .getColorScheme()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: resp => {
          if (resp.scheme) {
            this.currentScheme = resp.scheme;
            this.themeSvc.setColorScheme(resp.scheme);
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  public listUpload: Array<string> = [
    'KnowledgeBase',
    'AW KnowledgeBase',
    'Rip KnowledgeBase',
    'IW KnowledgeBase',
    'UIConfig',
  ];

  changeTheme(ev: MatRadioChange) {
    if (ev.value && ev.value !== '') {
      this.themeSvc.setTheme(ev.value);
      this.prefSrvc
        .saveTheme(ev.value)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe();
    } else {
      this.themeSvc.setTheme(this.themeSvc.firmTheme());
      this.prefSrvc
        .saveTheme(this.themeSvc.firmTheme())
        .pipe(takeUntil(this.unsubscribe))
        .subscribe();
    }
  }

  changeScheme(ev: MatRadioChange) {
    this.themeSvc.setColorScheme(ev.value);
    this.prefSrvc
      .saveColorScheme(ev.value)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe();
  }
}
